/* global Swiper */
document.addEventListener("DOMContentLoaded", () => {

    const sliders = document.querySelectorAll(".b-hero-slider");
    sliders.forEach((slider) => {


        const slides = slider.querySelectorAll(".b-slide");
        Array.from(slides).forEach((child) => {
            child.classList.add("swiper-slide");
        });

        if (slides.length > 1) {
            if (slides.length < 4) {
                slides.forEach((slide) => {
                    slide.parentNode.appendChild(slide.cloneNode(true));
                });
            }


            const fullWidth = slider.dataset.fullWidth;
            const navigation = slider.dataset.navigation;
            const enableAutoplay = slider.dataset.autoplay;
            const slidesCount = slider.querySelectorAll('.swiper-slide').length;

            let enableNavigation = false;
            let enablePagination = false;

            if (navigation === "arrow") {
                enableNavigation = true;
            } else if (navigation === "pagination") {
                enablePagination = true;
            }


            let autoplayObj = enableAutoplay ?
                {
                    delay: 5000
                } : {};

            let navigationObj = enableNavigation ?
                {
                    nextEl: ".swiper-button--next",
                    prevEl: ".swiper-button--prev",
                } : {};

            let paginationObj = enablePagination ?
                {
                    el: ".swiper-pagination",
                    clickable: true, // To umożliwia kliknięcie
                    type: 'bullets', // Typ paginacji
                } : {};

            if (fullWidth === "true") {

                new Swiper(slider, {
                    spaceBetween: 16,
                    loop: slidesCount > 1,
                    centeredSlides: true,
                    slidesPerView: 1,
                    navigation: navigationObj,
                    pagination: paginationObj,
                    freeMode: false,
                    autoplay: autoplayObj,
                });
            } else {
                const mainSliderThumbs = new Swiper(".js-b-hero-slider__thumbs", {
                    loop: slidesCount > 1,
                    spaceBetween: 56,
                    slidesPerView: "auto",
                    freeMode: true,
                    watchSlidesProgress: true,
                });
                new Swiper(slider, {
                    spaceBetween: 16,
                    loop: slidesCount > 1,
                    centeredSlides: true,
                    slidesPerView: "auto",
                    thumbs: {
                        swiper: mainSliderThumbs,
                    },
                    navigation: navigationObj,
                    autoplay: autoplayObj,
                });
            }
        }
    });
});